module.exports = __webpack_public_path__ + "img/icm-webinar-popup.78c68328.png";